import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';

export interface Author {
  id: number;
  name: string;
  position: string;
  image: number;
}

export class AuthorService extends AuthenticatedService {
  public list = async (): Promise<IHttpResponse<Author[]>> => {
    const authors = await this.getAuth<Author[]>(
      'authors',
    );

    return authors;
  }

  public byId = async (id: number): Promise<IHttpResponse<Author>> => {
    const author = await this.getAuth<Author>(
      `authors/${id}`,
    );

    return author;
  }

  public create = async (author: Author): Promise<IHttpResponse<Author>> => {
    const newAuthor = await this.postAuth<Author>(
      'authors', author,
    );

    return newAuthor;
  }

  public update = async (author: Author): Promise<IHttpResponse<Author>> => {
    const newAuthor = await this.putAuth<Author>(
      `authors/${author.id}`, author,
    );

    return newAuthor;
  }

  public remove = async (id: number): Promise<IHttpResponse<Author>> => {
    const newAuthor = await this.deleteAuth<Author>(
      `authors/${id}`,
    );

    return newAuthor;
  }

  public image = (id: number): string => {
    return `${this.config.BaseUrl}/authors/image/${id}`;
  }
}
